import commonApi from './CommonApi.js';

var qs = require('querystring');

export default {
	postMessage: async (viewModel) => {
		return await commonApi().post('/v1/chatEping/postMessage', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	submitFeedback: async (viewModel) => {
		return await commonApi().post('/v1/chatEping/submitFeedback', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	}
}